import { useState, useEffect, useContext } from 'react';


// New
function LiveReserveSituationLineBatchNew(props: any) {
  const info = props.info;

  return (
    <>
    {Number(info.is_new) === 1?
      <span className="label label-danger flashing" style={{ marginLeft: '10px' }}>NEW</span>
    :
      <>
        {Number(info.is_new) === 2 &&
          <span className="label label-danger flashing" style={{ marginLeft: '10px' }}>おすすめ！</span>
        }
      </>
    }
    </>
  );
}
  
export default LiveReserveSituationLineBatchNew;